import React, { ReactElement } from "react";
import { GQLCategories } from "@gql/types/gql";
import Image from "next/legacy/image";
import Link from "@components/shared/linkNoPrefetch";
import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import blogImgPlaceholder from "@public/placeholder_several.jpg";

export default function CategoryArticles({
    categories,
}: {
    categories: GQLCategories[];
}): ReactElement {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <section className="mb-24">
            {categories.map((category) => (
                <div key={category.id} className=" mt-20">
                    <div className="flex   items-center  border-b-4 border-b-[#1693F0] relative ">
                        <h2 className="font-bold  lg:text-2xl text-xl text-[#1693F0] bg-white sm:absolute sm:pe-16   ltr:left-[-1px] rtl:right-[-1px] pb-5 sm:pb-2 sm:py-2 ">
                            {category.label ?? category.name}
                        </h2>
                    </div>
                    <div className="lg:mt-9  flex flex-wrap justify-between flex-col lg:flex-row ">
                        {category?.posts?.map((post, index) => (
                            <div
                                key={post?.id}
                                className={`flex sm:flex-row   cursor-pointer  py-7 gap-4  w-full lg:w-[47%] ${
                                    styles["borderStyle"]
                                } relative ${
                                    index ===
                                        (category?.posts?.length as number) -
                                            1 ||
                                    index ===
                                        (category?.posts?.length as number) - 2
                                        ? ""
                                        : "border-b"
                                }`}
                            >
                                <div className="relative min-w-[155px] w-[155px]   h-[99px] ">
                                    {post?.image?.fullPath ? (
                                        <Image
                                            src={post?.image?.fullPath}
                                            alt={post?.title as string}
                                            width={155}
                                            height={99}
                                            sizes="(min-width: 320px) 33vw"
                                        />
                                    ) : (
                                        <Image
                                            src={blogImgPlaceholder.src}
                                            alt={post?.title as string}
                                            width={155}
                                            height={99}
                                            sizes="(min-width: 320px) 33vw"
                                        />
                                    )}
                                </div>
                                <div className=" flex flex-col justify-between ">
                                    <p className="   sm:font-bold font-semibold sm:text-base text-sm">
                                        {post?.title}
                                    </p>
                                    <Link
                                        href={post?.url?.url as string}
                                        key={post?.id}
                                        className={`${styles["overlayLink"]}   block w-fit sm:text-base text-sm `}
                                    >
                                        {translate(
                                            translations,
                                            "several_general_readMoreButton",
                                        )}
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>

                    <Link
                        href={`/blog/category/${category.slug as string}`}
                        className="block text-center mt-5 sm:text-lg text-base font-semibold  w-fit mx-auto "
                    >
                        {translate(
                            translations,
                            "several_general_showMoreButton",
                        )}
                    </Link>
                </div>
            ))}
        </section>
    );
}
